import { LadiesMain } from "../global/ladies-main"

window.closeBuyCoinsModal = () => {
    $("#coins-modal").modal("hide")
    LadiesMain.removeHashtagFromUrl("coins-modal")
}

window.successfulBuyCoinsModal = () => {
    openSubscriptionModalIfSet()
    openSubscriptionModalBuyButtonsIfSet()
}

window.redirectWithCorrectReferrer = (args) => {
    const isLoggedIn = userData.isLoggedIn
    if (!isLoggedIn && args && args.reLogin) {
        // no reLogin if not loggedIn already
        return
    }
    window.location.href = `/login?ref=${encodeURIComponent(window.location.pathname + window.location.hash)}`
}

window.redirectWithCorrectReferrerForRegistration = () => {
    // Currently this logic cant be used as we cant redirect after login to the modal
    const isLoggedIn = userData.isLoggedIn
    if (isLoggedIn) {
        // no reLogin if not loggedIn already. To be fair i dont know what this does and just copied from above.
        //Normally this case shouldnt happen and i dont know why i am even checking this.
        return
    }

    window.location.href =
        SiteInfo.loginUrl + `/register?ref=${encodeURIComponent(window.location.pathname + window.location.hash)}`
}

window.openSubscriptionModalIfSet = () => {
    if (LadiesMain.checkHashtagInUrl("success-modal")) {
        const successModal = LadiesMain._getHashtagObject()["success-modal"]
        const ownerId = LadiesMain._getHashtagObject()["owner-id"]
        const subscriptionButton = document.querySelector(`[data-content="#${successModal}"]`)
        const subscriptionModal = document.getElementById("subscriptionModal")
        if (
            subscriptionButton &&
            (subscriptionModal.style.display === "none" || subscriptionModal.style.display === "")
        ) {
            subscriptionButton.setAttribute("data-target", "#subscriptionModal")
            if (ownerId) {
                subscriptionButton.setAttribute("value", ownerId)
            }
            subscriptionButton.click()
        }
    }
}

window.openSubscriptionModalBuyButtonsIfSet = () => {
    if (LadiesMain.checkHashtagInUrl("subscription-modal-buy-buttons")) {
        LadiesMain.removeHashtagFromUrl("subscription-modal-buy-buttons")
        const subscriptionModalBuyButtons = document.querySelector("#become-a-fan")
        if (subscriptionModalBuyButtons) {
            subscriptionModalBuyButtons.click()
        }
    }
}

window.showPaymentModal = async () => {
    const paymentState = LadiesMain._getHashtagObject()["payment_state"]
    const coinsModalPaymentProcess = document.getElementById("coins-modal-payment-processed")
    const coinsModalPaymentProcessText = document.getElementById("coins-modal-payment-processed-text")
    const coinsModalPaymentProcessHeader = document.getElementById("coins-purchase-after-header")

    if (paymentState === "payment_success") {
        const boughtCoinAmount = LadiesMain._getHashtagObject()["selected_quantity"]
        coinsModalPaymentProcessHeader.innerHTML = "Kaufvorgang erfolgreich abgeschlossen!"
        coinsModalPaymentProcessText.innerHTML = boughtCoinAmount + " Coins wurden erfolgreich aufgeladen."
    } else {
        coinsModalPaymentProcessHeader.innerHTML = "Kaufvorgang fehlgeschlagen!"
        coinsModalPaymentProcessText.innerHTML =
            "Transaktion fehlgeschlagen! Bitte versuchen Sie es erneut. Bei weiteren Problemen loggen sich sie sich aus und wieder ein oder melden sie sich direkt bei unserem Support."
    }

    coinsModalPaymentProcess.style.display = "block"
    LadiesMain.removeHashtagFromUrl("payment_state")
    LadiesMain.removeHashtagFromUrl("selected_quantity")
}

window.hidePartialPaymentModal = () => {
    const coinsModalPaymentProcess = document.getElementById("coins-modal-payment-processed")
    coinsModalPaymentProcess.style.display = "none"
}

window.hidePaymentOptionsModal = () => {
    const coinModalOptionsContents = document.querySelectorAll(".buy-coins-options-component")
    if (coinModalOptionsContents.length > 0) {
        for (const coinModalContent of coinModalOptionsContents) {
            coinModalContent.style.display = "none"
        }
    }
}

$("#coins-modal").on("show.bs.modal", async (e) => {
    if (SiteInfo.buyCoinsUrl !== "") {
        hidePaymentOptionsModal()
    }
    if (e.relatedTarget?.dataset["content"]) {
        const successModal = e.relatedTarget.dataset["content"].slice(1)

        if (successModal) {
            LadiesMain.addHashtagToUrl("success-modal", successModal)
        }
    }
    LadiesMain.addHashtagToUrl("coins-modal")
    hidePartialPaymentModal()

    if (!LadiesMain.checkHashtagInUrl("payment_state") && SiteInfo.buyCoinsUrl !== "") {
        window.location.href = SiteInfo.buyCoinsUrl + "?originUrl=" + encodeURIComponent(window.location.href)
    }

    if (LadiesMain.checkHashtagInUrl("payment_state")) {
        await showPaymentModal()
    }
})

$("#coins-modal").on("hide.bs.modal", () => {
    LadiesMain.removeHashtagFromUrl("coins-modal")
    successfulBuyCoinsModal()
})

function renderNotLoggedInButtonIfNecessary() {
    const isLoggedIn = userData.isLoggedIn
    if (isLoggedIn) {
        return
    }

    const coinsModalLogin = document.getElementById("coins-modal-login")
    if (!coinsModalLogin) {
        return
    }

    document.getElementById("coins-modal-login-button").addEventListener("click", () => {
        redirectWithCorrectReferrer()
    })
    document.getElementById("coins-modal-register-link").addEventListener("click", () => {
        redirectWithCorrectReferrerForRegistration()
    })
}

$(document).ready(() => {
    if (LadiesMain.checkHashtagInUrl("coins-modal")) {
        $("#coins-modal").modal("show")
        renderNotLoggedInButtonIfNecessary()
    } else {
        $("#coins-modal").modal("hide")
    }
})
